import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import { forEach } from "lodash";
export const useApplicationPathIndexes = (path, indexes) => {
  let pathWithIndexes = path;
  forEach(indexes, (index, key) => pathWithIndexes = pathWithIndexes.replace(`[${key}][{index}]`, `[${key}][${index}]`));
  const pathWithoutIndexes = path.replace(/\d/g, "{index}");
  const pathSplit = path.split(/[[\]]{1,2}/);
  pathSplit.shift();
  pathSplit.pop();
  const indexesFromPath = _reduceInstanceProperty(pathSplit).call(pathSplit, (acc, curr, index) => {
    if (/\d/g.test(curr)) {
      acc[pathSplit[index - 1]] = _parseInt(curr);
    }
    return acc;
  }, {});
  return {
    pathWithIndexes,
    pathWithoutIndexes,
    indexesFromPath
  };
};
export const useApplicationPathIndexesV2 = (path, indexes) => {
  let pathWithIndexes = path;
  forEach(indexes, (index, key) => pathWithIndexes = pathWithIndexes.replace(`[${key}]`, `[${key}][${index}]`));
  const pathWithoutIndexes = path.replace(/\d/g, "{index}");
  const pathSplit = path.split(/[[\]]{1,2}/);
  pathSplit.shift();
  pathSplit.pop();
  const indexesFromPath = _reduceInstanceProperty(pathSplit).call(pathSplit, (acc, curr, index) => {
    if (/\d/g.test(curr)) {
      acc[pathSplit[index - 1]] = _parseInt(curr);
    }
    return acc;
  }, {});
  return {
    pathWithIndexes,
    pathWithoutIndexes,
    indexesFromPath
  };
};